import { useEffect, useState } from "react";
import * as bannerApi from "src/api/banner";

const useBanner = ({
  bannerKey,
  resource,
  options = {
    autoFetch: true, // Fetch data automatically when the hook is called
  },
}) => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch a specific banner resource
  const fetchBanners = async () => {
    setLoading(true);
    try {
      const images = await bannerApi.getBanners(bannerKey, resource);
      setBanners(images);
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const addBanner = async (newBanner) => {
    setLoading(true);
    try {
      await bannerApi.addBanner(bannerKey, resource, newBanner);
      //   fetchBanners(); // Refresh banner data after update
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // Update a specific image in a banner
  const updateBanner = async (updatedBanner) => {
    setLoading(true);
    try {
      await bannerApi.updateBanner(bannerKey, resource, updatedBanner);
      //   fetchBanners(); // Refresh banner data after update
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // Update multiple images in a banner
  const updateBanners = async (updatedBanners) => {
    setLoading(true);
    try {
      await bannerApi.updateBanners(bannerKey, resource, updatedBanners);
      //   fetchBanners(); // Refresh banner data after update
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // Delete a specific image in a banner
  const deleteBanner = async (position) => {
    setLoading(true);
    try {
      await bannerApi.deleteBanner(bannerKey, resource, position);
      //   fetchBanners(); // Refresh banner data after update
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const toggleVisibility = async (position) => {
    setLoading(true);
    try {
      await bannerApi.toggleVisibility(bannerKey, resource, position);
      //   fetchBanners(); // Refresh banner data after update
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (options?.autoFetch) fetchBanners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    banners,
    loading,
    error,
    setBanners,
    fetchBanners,
    addBanner,
    updateBanner,
    updateBanners,
    deleteBanner,
    toggleVisibility,
  };
};

export default useBanner;
